<div class="news-list">
    <ul class="news-items">
        <upsc-news-item *ngFor="let item of displayedItems" [item]="item"></upsc-news-item>
    </ul>
</div>
